// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"2bd1bec2","538":"3a8602d7","746":"d14ef97a"}[chunkId] + ".chunk.js";
};